module.exports = __webpack_public_path__ + "static/media/kids_28.7dd1c89e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_28.jpg
// module id = 5884
// module chunks = 0